/* eslint-disable react/jsx-props-no-spreading */
import Text from '../../Text';
import { CheckboxProps } from './types';
import { Checkmark } from '../icons/Checkmark';

export const Checkbox = ({
  checked,
  id,
  labelText,
  name,
  onChange = () => {},
  type = 'checkbox',
  color = '#000000',
  ...rest
}: CheckboxProps) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div
      className="tw-border tw-border-solid tw-border-b tw-min-w-[13px] tw-min-h-[13px]"
      {...rest}
    >
      <Text
        as="label"
        className="tw-relative tw-cursor-pointer tw-select-none tw-pointer-events-auto tw-flex tw-items-center tw-justify-center tw-w-[13px] tw-h-[13px] "
        html-for={id}
        aria-label={labelText}
        data-qa="select-box"
      >
        {labelText && (
          <Text as="span" ellipsis className=" tw-pl-4 tw-pb-0 tw-leading-[12px]">
            {labelText || ''}
          </Text>
        )}
        <input
          name={name}
          id={id}
          type={type}
          checked={checked}
          onChange={onChange}
          className="tw-peer tw-absolute tw-opacity-0 tw-cursor-pointer tw-left-0"
        />
        {type === 'radio' && (
          <span className="tw-absolute tw-border-solid tw-border tw-cursor-pointer tw-h-3 tw-w-3 tw-top-[2px] tw-left-0 peer-checked:tw-bg-black" />
        )}
        {type === 'checkbox' && checked && <Checkmark color={color} />}
      </Text>
    </div>
  );
};
